import { useState, useEffect } from 'react';
import { iconMap } from '../constants/iconMap';
export const useGetSeatIcons = brandCode => {
  const [seatIcons, setSeatIcons] = useState({});
  useEffect(() => {
    let cancelled = false;
    const loadIcon = async (brand, key) => {
      try {
        const module = await import(`@eti/assets/icons/seating-buttons/${brand}/seatButton-${key}.svg`);
        return module.ReactComponent;
      } catch (e) {
        // oxlint-disable-next-line no-console
        console.error(`[useGetSeatIcons] Failed to load icon: brand=${brand}, key=${key}`, e);
        return null;
      }
    };
    const loadAllIcons = async () => {
      const iconKeys = ['selected', ...Object.values(iconMap).filter(Boolean)];
      const loadedIcons = await Promise.all(iconKeys.map(async key => {
        var _await$loadIcon;
        const icon = (_await$loadIcon = await loadIcon(brandCode, key)) !== null && _await$loadIcon !== void 0 ? _await$loadIcon : await loadIcon('default', key);
        return [key, icon];
      }));
      if (!cancelled) {
        setSeatIcons(Object.fromEntries(loadedIcons));
      }
    };
    loadAllIcons();
    return () => {
      cancelled = true;
    };
  }, [brandCode]);
  return seatIcons;
};
//# sourceMappingURL=useGetSeatIcons.js.map